// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__1lDh3","insightsList":"newBusinessInsightsMenu_insightsList__1oJhj","active":"newBusinessInsightsMenu_active__2inOE"};